/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_No_ConflictsInputs */



/**
* | output |
* | --- |
* | "All members have access to all linked spaces." |
*
* @param {Project_Access_No_ConflictsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_no_conflicts = /** @type {((inputs?: Project_Access_No_ConflictsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_No_ConflictsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Mitglieder haben Zugriff auf alle verknüpften Spaces.")
	return /** @type {LocalizedString} */ ("All members have access to all linked spaces.")
});